document.querySelectorAll('.tab-title').forEach(tab => {
  tab.addEventListener('click', function () {

    document.querySelectorAll('.tab-title').forEach(t => t.classList.remove('active'));
    document.querySelectorAll('.tab-content').forEach(c => c.classList.remove('active'));

    this.classList.add('active');
    document.getElementById(this.dataset.tab).classList.add('active');

  });
});
document.addEventListener("DOMContentLoaded", function () {

  const triggers = document.querySelectorAll("[data-supp-pop-trigger]");

  triggers.forEach(trigger => {

    const parent = trigger.closest("section, div") || document;

    const modal = parent.querySelector("[data-supp-pop-modal]");
    const overlay = parent.querySelector("[data-supp-pop-overlay]");
    const closeBtn = parent.querySelector("[data-supp-pop-close]");

    if (!modal || !overlay) return;

    function openPopup() {

      // 🔥 Close all other popups first
      document.querySelectorAll("[data-supp-pop-modal]").forEach(m => {
        m.hidden = true;
        m.setAttribute("aria-hidden", "true");
      });

      document.querySelectorAll("[data-supp-pop-overlay]").forEach(o => {
        o.hidden = true;
      });

      // Open current
      modal.hidden = false;
      overlay.hidden = false;
      modal.setAttribute("aria-hidden", "false");
    }

    function closePopup() {
      modal.hidden = true;
      overlay.hidden = true;
      modal.setAttribute("aria-hidden", "true");
    }

    trigger.addEventListener("click", openPopup);

    if (closeBtn) {
      closeBtn.addEventListener("click", closePopup);
    }

    overlay.addEventListener("click", closePopup);

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") {
        closePopup();
      }
    });

  });


  $('.main-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: false,
    asNavFor: '.thumb-slider'
  });

  $('.thumb-slider').slick({
    slidesToShow: 8,
    slidesToScroll: 1,
    asNavFor: '.main-slider',
    focusOnSelect: false,
    arrows: false
  });

});

function initMobileMenuAccordion() {
  const isMobile = window.innerWidth <= 999;
  document.querySelectorAll(".menu_link").forEach(button => {
    // Remove previous click (important on resize)
    button.onclick = null;
    const content = button.nextElementSibling;
    if (isMobile) {
      button.addEventListener("click", function () {
        // Close others
        document.querySelectorAll(".menu_content").forEach(item => {
          if (item !== content) {
            item.classList.remove("active");
          }
        });
        // Toggle current
        content.classList.toggle("active");
      });

    } else {
      // Desktop → always open
      if (content) content.classList.add("active");
    }
  });
}

window.addEventListener("load", initMobileMenuAccordion);
window.addEventListener("resize", initMobileMenuAccordion);
document.addEventListener('DOMContentLoaded', function() {
  var rating = document.querySelector('.custom_ratting');
  if (rating) {
    rating.addEventListener('click', function() {
      var reviews = document.querySelector('.shopify-section--apps');
      if (reviews) {
        reviews.scrollIntoView({ behavior: 'smooth' });
      }
    });
  }
});